
























import {Component, Prop, Vue} from 'vue-property-decorator';
import JdhInlineLoader from "@/design-system/shared/JdhInlineLoader.vue"
import {Location} from "vue-router"

/**
 * @changelog $next Published.
 */
@Component( {
    components: {JdhInlineLoader}
})
export default class JdhStructuralButton extends Vue {

    @Prop({default: 'medium'}) size!: 'large'|'medium'|'small'
    @Prop({default: 'block'}) layout!: 'block'|'inline'|'fill'
    @Prop({default: 'default'}) state!: 'default'|'loading'|'disabled'
    @Prop({default: 'secondary'}) type!: 'primary'|'secondary'|'tertiary'|'danger'
    @Prop() icon!: string
    @Prop() trailingIcon!: string
    @Prop() href!: string
    @Prop() to!: Location

    get styles() {
        return {}
    }

    get buttonClasses() {
        if (this.state === 'disabled') return ['jdsc-structural-button--disabled']
        return []
    }

    get mainContentClasses() {
        if (this.state === 'loading') return ['jdsc-structural-button__content--hidden']
        if (this.state === 'disabled') return ['jdsc-structural-button__content--disabled']
        return []
    }

    get tag () {
        if (this.to) return 'router-link'
        if (this.href) return 'a'
        return 'button'
    }

    get showArrow() {
        if (this.icon) return false
        return this.to || this.href
    }

}
